/**
 * @prettier
 */

// eslint-disable-next-line import/prefer-default-export
export const STEPS = {
  FILE_UPLOAD: 'FILE_UPLOAD',
  PHOTO_CROP: 'PHOTO_CROP',
  MULTI_UPLOAD_HELP: 'MULTI_UPLOAD_HELP',
  CUSTOMIZATION: 'CUSTOMIZATION',
  WEDDING_DETAILS_FORM: 'WEDDING_DETAILS_FORM',
  SHIPPING_DETAILS_FORM: 'SHIPPING_DETAILS_FORM',
  ACCOUNT_DETAILS_FORM: 'ACCOUNT_DETAILS_FORM',
  SAMPLE_PREVIEW: 'SAMPLE_PREVIEW',
  FLOW_COMPLETION: 'FLOW_COMPLETION',
};



// WEBPACK FOOTER //
// ./src/cards/components/common/SingleSample/constants/steps.js